import DeviceType from '../DeviceType';
import LocalStorage from './LocalStorage';
import SessionStorage from './SessionStorage';
import TizenKeyStorage from './Tizen';
//import OrsayKeyStorage from './Orsay';
import OrsayKeyStorage from './Tizen';
import LGKeyStorage from './LG';

export const STORE_KEY = {
  POWER_STATE: 'POWER_STATE',
  DEVICE_ID: 'device_id',
  BUILDING_ID: 'bid',
  ROOM: 'room',
  LANG: 'lang',
  SERIAL_NUMBER: 'serial_number',
  FINGERPRINT: 'fingerprint',
};

export const STORE_VALUE = {
  POWER_ON: 'ON',
  POWER_OFF: 'OFF',
};

export default class StorageHandler {
  static save(key, value) {
    if(DeviceType.isTizen) {
      return TizenKeyStorage.save(key, value);
    } else if(DeviceType.isLG) {
      return LGKeyStorage.save(key, value);
    } else if(DeviceType.isOrsay) {
      return OrsayKeyStorage.save(key, value);
    } else {
      LocalStorage.save(key, value);
    }
  }

  static get(key) {
    if(DeviceType.isTizen) {
      return TizenKeyStorage.get(key);
    } else if(DeviceType.isLG) {
      return LGKeyStorage.get(key);
    } else if(DeviceType.isOrsay) {
      return OrsayKeyStorage.get(key);
    } else {
      return LocalStorage.get(key);
    }
  }

  static remove(key) {
    if(DeviceType.isTizen) {
      return TizenKeyStorage.remove(key);
    } else if(DeviceType.isLG) {
      return LGKeyStorage.remove(key);
    } else if(DeviceType.isOrsay) {
      return OrsayKeyStorage.remove(key);
    } else {
      return LocalStorage.remove(key);
    }
  }

  static saveInSession(key, value) {
    SessionStorage.save(key, value);
  }
  static getSession(key) {
    return SessionStorage.get(key);
  }
}



// WEBPACK FOOTER //
// ./src/helpers/StorageHandler/index.js